import { ChangeEvent } from 'react'
import { v4 } from 'uuid'

import cn from '@/utilities/cn'

type CheckboxProps = {
  id?: string
  label?: string
  description?: string
  checked?: boolean
  disabled?: boolean
  className?: string
  boldHeaders?: boolean
  onChange: (value: ChangeEvent<HTMLInputElement>) => void
}
export default function Checkbox({
  id = v4(),
  label,
  description,
  checked,
  className = '',
  onChange,
  disabled,
  ...rest
}: CheckboxProps) {
  return (
    <div className={cn(className, 'mt-8 flex items-center')}>
      <input
        id={id}
        disabled={disabled}
        checked={checked}
        onChange={onChange}
        type="checkbox"
        className="h-4 w-4 rounded border-gray-300 text-blue-600 hover:cursor-pointer focus:ring-blue-600"
        {...rest}
      />
      {(label || description) && (
        <div className="ml-3 flex flex-col text-sm leading-6">
          {label && (
            <label htmlFor={id} className="text-sm font-medium text-gray-900 hover:cursor-pointer">
              {label}
            </label>
          )}
          {description && <span className="text-sm text-zinc-500">{description}</span>}
        </div>
      )}
    </div>
  )
}
